<template>
    <div class="allThumbnail">
        <h2><span class="el-icon-d-arrow-left" @click="back()"></span>All Thumbnail Info</h2>
        <div class="infoList"
             v-loading="loading"
             element-loading-text="Loading..."
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.8)"
        >
            <el-table
                    v-if="tableData.length"
                    :data="tableData"
                    style="width: 80%"
                    empty-text="  "
            >
                <el-table-column
                        prop="peerId"
                        label="Peer_ID"
                        align="center"
                        width="170">
                </el-table-column>

                <el-table-column
                        prop="resourceId"
                        label="ResourceID"
                        align="center"
                        width="200">
                </el-table-column>

                <el-table-column
                        prop="xmlContext"
                        label="IP"
                        align="center"
                        width="165">
                </el-table-column>

            </el-table>
            <Pagination
                    v-if="tableData.length"
                    @current-change="handleCurrentChange"
                    :current-page="pageNum"
                    :pageSizes="[25]"
                    :pageSize="25"
                    :total="total"
                    layout="total,prev, pageF, next, pageL,nowSize, jumper"
            />

        </div>


    </div>
</template>

<script>
    import Pagination from './common/Pagination';

    export default {
        name: "AllThumbnail",
        components:{
            Pagination
        },
        data(){
            return{
                tableData:[],
                params:{
                    timeStampDay:'',
                    timeEnd:'',
                    pageNumber:'1',
                    numEveryPage:'25',
                },
                total: 1,
                pageNum: 1,
                loading:false
            }
        },
        mounted() {
            this.showList();
        },
        methods:{
            back(){
                this.$router.go(-1);
            },
            showList(){
                this.params.timeStampDay = this.tranfromTime();
                this.params.timeEnd = this.tranfromTime();
                this.loading = true
                this.axios.post('/tp/web/ajaxRelayServlet/allThumbnailInfo',this.params).then(res => {
                    // console.log(res.data.result);
                    this.loading = false
                    this.tableData = res.data.result.list;
                    this.total = res.data.result.total;
                    this.pageNum = res.data.result.pageNum;
                }).catch(err => {
                    console.log(err);
                    this.loading = false
                })
            },
            tranfromTime() {       //转换时期
                let oDate = new Date();
                let oYear = oDate.getFullYear();
                let oMonth = oDate.getMonth() + 1;
                let oDay = oDate.getDate();
                let oTiem = this.fn_formatTime(oYear) + '-' + this.fn_formatTime(oMonth) + '-' + this.fn_formatTime(oDay);
                return oTiem;
            },
            fn_formatTime(date) { //给月份和日补零
                if (parseInt(date) < 10) {
                    date = '0' + date;
                }
                return date;
            },
            handleCurrentChange(val) {
                this.pageNum = val;
                this.params.pageNumber = val;
                this.params.numEveryPage = 25;
                this.showList();
            },
        }
    }
</script>

<style scoped lang="less">
.allThumbnail{
    width: 775px;
    max-width: 1024px;
    border: 0 solid gray;
    margin-top: -22px;
    margin-left: auto;
    margin-right: auto;
    background-color: #151515;
    color: white;

    h2 {
        span {
            padding-right: 15px;
            cursor: pointer;
        }
        color: #fff;
        font-size: 24px;
    }
    .infoList {
        padding-left: 30px;
        min-height: 50px;
        /*/deep/.el-table{*/
        /*    background: #151515;*/
        /*    /deep/.el-table thead{*/
        /*        background-color: #151515;*/
        /*    }*/
        /*}*/

        /deep/ .el-table--border::after, .el-table--group::after, .el-table::before {
            background-color: #151515;
        }

        /deep/ .el-table {
            background: #151515;
            color: #fff;
            margin: 15px auto;
            font-size: 16px;
            font-weight: 400;
            .el-table__header-wrapper {
                .has-gutter {
                    tr, th {
                        background: #33cc66;
                        border-bottom: 2px solid #33cc66;
                        color: #ffffff;
                        font-weight: 100;
                    }
                }
            }

            .el-table_row td, .el-table_row th {
                height: 50px;
                line-height: 50px;
                box-sizing: border-box;
                padding: 0;

                .cell {
                    line-height: 50px;
                    height: 50px;
                }
            }

            .el-table-row, tr {
                background: #151515;

                td {
                    border-bottom: 1px solid #333;
                }
            }

            .iconBox {
                margin-bottom: 0;
                display: none;
            }

            tr:hover {
                .iconBox {
                    display: block;
                }
            }

            tr:hover > td {
                background: none !important;
            }
        }
    }
}
</style>